import { IActivity } from "../../models/Workspaces/Activity";
import { IExternalAgent } from "./IExternalAgent";

interface IProps {
  agent: IExternalAgent;
  handleChange: (field: string, value: boolean) => void;
}

const ActivitiesList = [
  "booking",
  "support",
  "complains",
  "membership",
  "voicemail",
  "marketing",
  "dsr",
  "reception",
];

const Activities = ({ agent, handleChange }: IProps) => {
  return (
    <>
      Activities
      <hr />
      {ActivitiesList.map((activityKey: string, index: number) => {
        const activityLabel =
          activityKey.charAt(0).toUpperCase() + activityKey.slice(1);
        const activityValue = (agent as any)[activityKey] as boolean;
        return (
          <div key={index}>
            <input
              type="checkbox"
              checked={activityValue}
              onChange={(e) => handleChange(activityKey, e.target.checked)}
            />
            <span>{activityLabel}</span>
          </div>
        );
      })}
    </>
  );
};
export default Activities;
